import React, { useState } from "react";

function DateField({ response, onChange }) {
  const [value, setValue] = useState(response.value);
  return (
    <div className="form-group">
      <div className="row">
        <input
          className="form-control"
          type="date"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        />
      </div>
    </div>
  );
}

export default DateField;
